<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col cols="12" sm="5"> {{ titulo }}</v-col>
        <v-col cols="5" sm="3">
          <div>
            <p class="text-body-2 my-0">Ciclo</p>
            <p class="text-body-1 my-0 font-weight-bold">{{ datos.ciclo }}</p>
          </div></v-col
        >
        <v-col cols="7" sm="4">
          <div>
            <p class="text-body-2 my-0">Semestre</p>
            <p class="text-body-1 my-0 font-weight-bold">
              {{ datos.semestre == 1 ? "IMPAR (AGO-DIC)" : "PAR (FEB-JUL)" }}
            </p>
          </div>
        </v-col>
      </v-row>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  name: "CargaCicloSemestre",

  props: {
    titulo: String,
    datos: Object,
  },

  data: () => ({}),
};
</script>